export const reportGasMovementsTypes = {
  GET_REPORT_GAS_MOVEMENTS: 'GET_REPORT_GAS_MOVEMENTS',
  SET_REPORT_GAS_MOVEMENTS_FILTERS: 'SET_REPORT_GAS_MOVEMENTS_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};